export enum HotelsListDrawerComponent {
  HOTEL_CLASS = "HOTEL_CLASS",
  SEARCH_BY_NAME = "SEARCH_BY_NAME",
  ALL_FILTERS = "ALL_FILTERS",
  SORT = "SORT",
  PRICE = "PRICE",
  SEARCH = "SEARCH",
}
